import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const AlertExportContext = createContext(null);

type Props = {
  children: ReactElement;
};

const AlertExportProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post("tm/alerts/export", payload);
      return data;
    },
    onError: (err) => {
      console.log(err, "###");
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <AlertExportContext.Provider value={contextValue}>
      {children}
    </AlertExportContext.Provider>
  );
};

export default AlertExportProvider;
